var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.multiselectedAssets),function(asset){return [_c('InfoPanelSingle',{attrs:{"asset":asset}})]}),(_vm.multiselectedAssets.length < 1)?_c('InfoPanelEmpty'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }